import {
  IncomingCheckList,
  GetChecklistParams,
  IncomingChecklistItem,
  IncomingEmpDepartment,
  OutgoingAddPage,
} from '../../../types/Checklist/ChecklistTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../utils/apiUtils'
import { AllowedHttpMethods, CheckListApiConfig } from '../apiList'

const getChecklist = async (
  finalParams: GetChecklistParams,
): Promise<IncomingCheckList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CheckListApiConfig.getCheckList,
    method: AllowedHttpMethods.get,
    params: {
      ...finalParams,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getChecklistItem = async (
  pageName: string,
): Promise<IncomingChecklistItem> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CheckListApiConfig.getChecklistItem,
    method: AllowedHttpMethods.get,
    params: {
      pageName,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

// used in other components also.... CHANGE WITH CAUTION
const getEmpDepartments = async (): Promise<IncomingEmpDepartment[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CheckListApiConfig.getEmpDepartments,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const addPage = async (finalData: OutgoingAddPage): Promise<undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CheckListApiConfig.addPage,
    method: AllowedHttpMethods.post,
    data: {
      ...finalData,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const updateHandbookItem = async (
  finalData: IncomingChecklistItem,
): Promise<undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CheckListApiConfig.updateHandbookItem,
    method: AllowedHttpMethods.put,
    data: {
      ...finalData,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const deletePage = async (bookId: number): Promise<undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: CheckListApiConfig.deletePage,
    method: AllowedHttpMethods.delete,
    params: {
      bookId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const ChecklistApi = {
  getChecklist,
  getChecklistItem,
  getEmpDepartments,
  addPage,
  updateHandbookItem,
  deletePage,
}

export default ChecklistApi
